import { A as AutoScroll } from './embla-carousel-auto-scroll.esm-7BmXHxKm.js';
import { L as LoopingCarousel } from './looping-carousel-CUmlCHAQ.js';
import './embla-carousel.esm-CCUHK2kO.js';

class Marquee extends LoopingCarousel() {
  emblaOptions = {
    loop: true,
    align: 'start',
    dragFree: true,
    direction: document.dir,
    watchSlides: false,
  };

  get emblaPlugins() {
    return [
      AutoScroll({
        startDelay: 0,
        stopOnInteraction: false,
        stopOnMouseEnter: true,
        speed: Number(this.viewport.dataset.speed),
      }),
    ];
  }

  onInit(embla) {
    embla.plugins().autoScroll.play();
  }
}

customElements.define('marquee-element', Marquee);
